import React, { memo } from 'react';
import { StyleSheet } from 'react-native';

import { IllusEmpty_2 } from '../../../assets';
import { useResponsive } from '../../../hooks';
import type { CloudinaryTransformConfig } from '../../Image';
import { FallbackImage } from '../../Image';

export const ProductCardImage = memo((props: ProductCardImageProps) => {
  const { baseUrl, size } = props;
  const { match } = useResponsive();

  const regular = match([styles.imageRegularXS_SM, styles.imageRegularMD_LG]);
  const large = match([styles.imageLargeXS_SM, styles.imageLargeMD_LG]);
  const imageStyle = size === 'large' ? large : regular;
  const cloudinaryConfig =
    size === 'large'
      ? CARD_IMG_TRANSFORM_CONFIG_LARGE
      : CARD_IMG_TRANSFORM_CONFIG_REGULAR;

  return (
    <FallbackImage
      baseUrl={baseUrl}
      defaultImage={IllusEmpty_2}
      testID="product-card-image"
      resizeMode="contain"
      style={imageStyle}
      cloudinaryConfig={cloudinaryConfig}
    />
  );
});

// ─── Constants ───────────────────────────────────────────────────────────────

const CARD_IMG_TRANSFORM_CONFIG_REGULAR: CloudinaryTransformConfig = [
  { crop: 'crop', height: 0.62, width: 0.62 },
  { width: 310 },
];

const CARD_IMG_TRANSFORM_CONFIG_LARGE: CloudinaryTransformConfig = [
  { crop: 'crop', height: 0.6, width: 0.4 },
  { width: 310 },
];

const IMAGE_SIZE_REGULAR_XS_SM = 220;
const IMAGE_SIZE_REGULAR_MD_LG = 180;

const IMAGE_SIZE_LARGE_XS_SM = 311;
const IMAGE_SIZE_LARGE_MD_LG = 274;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  imageRegularXS_SM: {
    width: '100%',
    height: IMAGE_SIZE_REGULAR_XS_SM,
  },
  imageRegularMD_LG: {
    width: '100%',
    height: IMAGE_SIZE_REGULAR_MD_LG,
  },
  imageLargeXS_SM: {
    width: '100%',
    height: IMAGE_SIZE_LARGE_XS_SM,
  },
  imageLargeMD_LG: {
    width: '100%',
    height: IMAGE_SIZE_LARGE_MD_LG,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ProductCardImageProps = Readonly<{
  baseUrl: string;
  size: 'regular' | 'large';
}>;
